export default __webpack_public_path__ + "static/media/acceptTerms.e0ca8d84.svg";